import React, { Component } from "react";
import axios from "axios";
import { config } from "../../../../utils/domain_config";
import { Row, Col } from "reactstrap";
import "./style.css";
import Loader from "./../../loader/loader";
import history from "./../../../../utils/history";
import { FormattedMessage } from "react-intl";
import { sendData } from "../../../../analytics/sendData";
import { getDomainName, isMobioPlus } from "../../../../utils/isMobio+";

class Login extends Component {
  constructor(props) {
    super(props);
    const countryCode = {
      ee: 372,
      es: 34,
      fr: 33,
      gr: 30,
      eg: 20,
      jo: 962,
      ps: 970,
      pl: 48,
      nl: 31,
      ie: 353,
      bh: 973,
      rs: 381,
      uk: 44,
      za: 27,
      ro: 40,
    };
    this.state = {
      msisdn:
        countryCode[
          JSON.parse(sessionStorage.getItem("countryCode")).countryCode
        ],
      isValid: false,
      errorMessage: "",
      domain: window.location.host.includes("localhost")
        ? "ie.mobioastro.com"
        : window.location.host,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeMsisdn = this.onChangeMsisdn.bind(this);
    this.isValid = this.isValid.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.callAuthenticate = this.callAuthenticate.bind(this);
  }

  isValid() {
    if (this.state.msisdn == "") {
      this.setState({
        isValid: false,
        errorMessage: "Phone number is required.",
      });
      return false;
    }
    return true;
  }

  onChangeMsisdn(e) {
    const { value, maxLength, name } = e.target;
    const truncatedValue = value.slice(0, maxLength);
    this.setState({ [name]: truncatedValue });
  }

  onKeyUp(e) {
    if (e.keyCode == 13) {
      if (this.isValid()) {
        this.setState({ isValid: true, errorMessage: "" });
        this.callAuthenticate({
          msisdn: this.state.msisdn,
        });
      }
    }
  }

  onSubmit(e) {
    e.preventDefault();
    if (this.isValid()) {
      this.setState({ isValid: true, errorMessage: "" });
      this.callAuthenticate({
        msisdn: this.state.msisdn,
      });
    }
  }

  componentDidMount() {
    if (
      JSON.parse(sessionStorage.getItem("loggedIn")) &&
      JSON.parse(sessionStorage.getItem("loggedIn")).loggedIn
    ) {
      history.push({
        pathname: "/",
      });
    }
  }

  callAuthenticate(data) {
    // this.props.show();
    let host = window.location.host.includes("localhost")
      ? "za.mobioastro.com"
      : window.location.hostname;
    let domain = host.split(".")[0];
    if (["bh"].indexOf(domain) >= 0) {
      axios
        .get(
          `https://eu-api.sam-media.com/api/v1/subscription/validate-access-samplatform-mcb/sammediacp?msisdn=${data.msisdn}&domain=${host}`
        )
        .then((response) => {
          // this.props.hide();
          if (response.data.status === 1) {
            sessionStorage.setItem(
              "loggedIn",
              JSON.stringify({ loggedIn: true })
            );
            sessionStorage.setItem("rockmanId", response.data.rockmanId);
            sessionStorage.setItem("start_date", response.data.subscribed_at);
            sessionStorage.setItem("end_date", response.data.next_renewal_date);
            sessionStorage.setItem("msisdn", response.data.msisdn);
            this.setState({ loading: false });
            history.push({
              pathname: "/",
            });
          } else {
            this.setState({ loading: false });
            history.push({
              pathname: "/accessDenied",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({ loading: false });
          history.push({
            pathname: "/accessDenied",
          });
        });
    } else if (["za"].indexOf(domain) >= 0) {
      axios
        .get(
          `https://eu-api.sam-media.com/api/v1/subscription/validate-access-samplatform-mcb/sammediacp?msisdn=${data.msisdn}&domain=${host}`
        )
        .then((response) => {
          // this.props.hide();
          if (response.data.state === "success") {
            sessionStorage.setItem(
              "loggedIn",
              JSON.stringify({ loggedIn: true })
            );
            sessionStorage.setItem(
              "rockmanId",
              response.data.payload.rockmanId
            );
            sessionStorage.setItem(
              "start_date",
              response.data.payload.startDate
            );
            sessionStorage.setItem(
              "end_date",
              response.data.payload.renewalDate
            );
            sessionStorage.setItem("msisdn", response.data.payload.msisdn_full);
            sessionStorage.setItem(
              "uid",
              JSON.stringify({ uid: response.data.payload.token })
            );
            this.setState({ loading: false });
            history.push({
              pathname: "/",
            });
          } else {
            this.setState({ loading: false });
            history.push({
              pathname: "/accessDenied",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({ loading: false });
          history.push({
            pathname: "/accessDenied",
          });
        });
    } else {
      axios
        .get(
          `https://de-mcb-api.sam-media.com/mcb/api/v2/validate-access/sam?msisdn=${data.msisdn}&domain=${host}`
        )
        .then((response) => {
          // this.props.hide();
          if (response.data.state === "success") {
            sessionStorage.setItem(
              "loggedIn",
              JSON.stringify({ loggedIn: true })
            );
            sessionStorage.setItem(
              "rockmanId",
              response.data.payload.rockmanId
            );
            sessionStorage.setItem(
              "start_date",
              response.data.payload.startDate
            );
            sessionStorage.setItem(
              "end_date",
              response.data.payload.renewalDate
            );
            sessionStorage.setItem("msisdn", response.data.payload.msisdn_full);
            sessionStorage.setItem(
              "uid",
              JSON.stringify({ uid: response.data.payload.token })
            );
            this.setState({ loading: false });
            history.push({
              pathname: "/",
            });
          } else {
            this.setState({ loading: false });
            history.push({
              pathname: "/accessDenied",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({ loading: false });
          history.push({
            pathname: "/accessDenied",
          });
        });
    }
  }

  render() {
    const logo = isMobioPlus
      ? require("./../../../assets/images/mobioplus_logo.svg")
      : require("./../../../assets/images/Logo.png");
    return (
      <div className="login animated fadeIn">
        <Row className="justify-content-center">
          <Col>
            <Row className="login-page-header">
              <div className="login-page-header-child">
                <img
                  className="login-page-logo"
                  src={logo}
                  alt="MobioAstro"
                  width="125px"
                />
              </div>
            </Row>
            <Row className="login-page-content">
              <h1>
                <FormattedMessage
                  id="areYouAlready"
                  defaultMessage={`Are you already a member of ${getDomainName()}?`}
                />
              </h1>
              <p>
                <FormattedMessage
                  id="thenConfirm"
                  defaultMessage="Then confirm your mobile number and get unlimited access to all our services!"
                />
              </p>

              <div className="login-page-mobile_num">
                <input
                  autoFocus
                  type="number"
                  name="msisdn"
                  maxLength="15"
                  value={this.state.msisdn}
                  onChange={this.onChangeMsisdn}
                  onKeyUp={this.onKeyUp}
                  className="LoginRoute-number"
                />
                <button
                  type="submit"
                  onClick={this.onSubmit}
                  className="LoginRoute-button"
                >
                  <FormattedMessage id="login" defaultMessage="Login" />
                  <i className="icon-back"></i>
                </button>
              </div>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/login/login.js